import * as types from '../types/actionTypes/productSegmentsType';
import ProductSegmentsApi from '../api/ProductSegmentsApi';
import { ProductSegmentsAction } from "../types/actionTypes/productSegmentsType";
import { AsyncAction } from '.';

export const getProductSegments = (): AsyncAction<ProductSegmentsAction> => {
    return async (dispatch) => {
        var productSegments = await ProductSegmentsApi.getProductSegments();
        return dispatch({ type: types.GET_PRODUCT_SEGMENTS, productSegments });
    }
}